<template>
  <nv-page :header="displayName">
    <template slot="toolbar">
      <v-spacer />
      <nv-btn type="back" />
    </template>

    <v-card class="pa-4">
      <v-row dense>
        <nv-show cols="12" sm="3" header="Parent">{{ item.parent }}</nv-show>
        <nv-show cols="12" sm="3" header="Name">{{ item.name }}</nv-show>
        <nv-show cols="12" sm="6" header="VCID">{{ item.vc_id }}</nv-show>
      </v-row>
    </v-card>

    <v-card class="mt-4 elevation-2">
      <v-tabs v-model="tabs" slider-color="accent">
        <v-tab>Applications</v-tab>
        <v-tab>Localized Sub-brands</v-tab>
      </v-tabs>
      <v-tabs-items v-if="item.id" v-model="tabs">
        <v-tab-item>
          <applications-tab-list :ddrs-id="item.id" />
        </v-tab-item>
        <v-tab-item>
          <entities-tab-pane :path="`/ddrs_entities/${item.id}/local_entities`" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </nv-page>
</template>

<script>
import HTTP from '@/api/dog';
import ApplicationsTabList from '@/components/applications/ApplicationsTabList.vue';
import EntitiesTabPane from '@/components/ddrs_entities/EntitiesTabPane';

export default {
  components: { EntitiesTabPane, ApplicationsTabList },
  data: () => ({
    item: {},
    tabs: 0,
  }),
  computed: {
    displayName() {
      return `${this.item.parent} / ${this.item.name} (${this.item.vc_id})`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      HTTP.get(`/ddrs_entities/${this.$route.params.ddrsId}`).then(res => {
        this.item = res.data;
      });
    },
  },
};
</script>
